import home from '../../pages/home'
import facadeList from '../../pages/facadeList'
import more from '../../pages/more'
import filter from '../../pages/filter'
import userCenter from '../../pages/userCenter'  
import siteList from '../../pages/siteList'
import sendCode from '../../pages/sendCode'
import login from '../../pages/login'
import noCode from '../../pages/noCode'
import toMsgCenter from '../../pages/toMsgCenter'  
import agreement from '../../pages/agreement'
import payMoney from '../../pages/payMoney'
import weixinPay from '../../pages/weixinPay'
export default[
    { 
        path: '/login', 
        component: login 
    },
    { 
        path: '/sendCode', 
        component: sendCode 
    },
    { 
        path: '/noCode', 
        component: noCode 
    },
    { 
        path: '/home', 
        component: home,
    },
    { 
        path: '/facadeList', 
        component: facadeList 
    },
    {
        path:'/more',
        component:more
    },
    {
        path:'/filter',
        component:filter
    },
    {
        path:'/userCenter',
        component:userCenter
    },
    {
        path:'/toMsgCenter',
        component:toMsgCenter
    },
    {
        path:'/siteList',
        component:siteList
    },
    {
        path:'/agreement',
        component:agreement
    },
    {
        path:'/payMoney',
        component:payMoney
    },
    {
        path:'/weixinPay',
        component:weixinPay
    },
    {
        path: '/', 
        redirect: '/home' 
    },
    { 
        path: '*', 
        redirect: '/home' 
    }
]



// WEBPACK FOOTER //
// ./src/common/js/router.js